import { useMutation } from "@tanstack/react-query";
import { feedbackApi } from "@wtf/shared/api/feedback";
import { SubmitFeedbackRequest, SubmitFeedbackResponse } from "@wtf/shared";

/**
 * Hook to submit feedback
 */
export function useSubmitFeedback() {
  return useMutation<SubmitFeedbackResponse, Error, SubmitFeedbackRequest>({
    mutationFn: (data) => feedbackApi.submitFeedback(data),
  });
}
